import { AutoMap } from '@automapper/classes';

export class PrelevementAirEntity {
    Id?: number;
    @AutoMap()
    Type!: number;
    @AutoMap()
    ReferenceTube!: string;
    @AutoMap()
    Duree!: number;
    @AutoMap()
    Resultat!: number;
    @AutoMap()
    Conformite!: boolean;
}
